module.exports = __webpack_public_path__ + "static/logo-light-mobil-837fb8f3e05b501ea8528dddf8de7e80.png";